import { render, staticRenderFns } from "./EditSubDomain.page.vue?vue&type=template&id=613a4483&"
import script from "./EditSubDomain.page.vue?vue&type=script&lang=js&"
export * from "./EditSubDomain.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports